import React, { useState, useEffect } from 'react';
import { Stack, Modal, Box, Typography, TextField, Button, Link, InputAdornment } from '@mui/material';
import { login } from '../../utils/api';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import ForgotPassword from '../UserAuthentication/ForgotPassword';
import GoogleIcon from '@mui/icons-material/Google'; // Import theGoogle icon
const Login = ({ open, onClose, onRegisterClick }) => {
    const [formData, setFormData] = useState({ username: '', password: '' });
    const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);

    const handleForgotPasswordSubmit = (email) => {
        setForgotPasswordOpen(false); // Close the modal after submission
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await login(formData);
            if (response && response.data) {
                localStorage.setItem('username', formData.username);
                localStorage.setItem('userId', response.data.userId);
                localStorage.setItem('role', response.data.role); // Updated to use response data
                localStorage.setItem('profileImage', formData.profileImage); // Store profileImage

                onClose();
                window.location.reload();
            } else {
                console.error('No data returned from the login API');
            }
        } catch (error) {
            console.error('Login error:', error.message);
        }
    };
    // Function to handle Google login redirection
    const handleGoogleLogin = () => {
        window.location.href = 'https://pilatesnflow.onrender.com/auth/google';//'http://localhost:5000/auth/google';//
    }
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const user = urlParams.get('user');

        if (token && user) {
            // Parse the user JSON string into an object
            const userObj = JSON.parse(decodeURIComponent(user));

            // Store the token and user information in localStorage
            localStorage.setItem('userId', userObj._id);
            localStorage.setItem('username', userObj.username);
            localStorage.setItem('email', userObj.email);
            localStorage.setItem('role', userObj.role);
            localStorage.setItem('googleId', userObj.googleId); // Store userId
            localStorage.setItem('profileImage', userObj.profileImage); // Store userId
            // Redirect to the main logged-in page
            window.location.href = '/';
        }
    }, []);


    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', boxShadow: 24, p: 4, borderRadius: '10px' }}>
                <Typography color="#B5A78A" fontFamily="GveretLevin" direction="rtl" textAlign="right" variant="h6" mb={2}>התחברות </Typography>
                <form onSubmit={handleSubmit}>
                    <TextField fullWidth margin="normal" label="שם משתמש" name="username" value={formData.username} onChange={(e) => setFormData({ ...formData, username: e.target.value })} required InputProps={{ startAdornment: <InputAdornment position="start"><PersonIcon /></InputAdornment> }} />
                    <TextField fullWidth margin="normal" type="password" label="סיסמה" name="password" value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} required InputProps={{ startAdornment: <InputAdornment position="start"><LockIcon /></InputAdornment> }} />

                    <Button type="submit" fullWidth variant="contained" sx={{
                        backgroundColor: '#C4A484',
                        '&:hover': { backgroundColor: '#C4A484' },
                        mt: 2,
                    }}>התחברות</Button>
                </form>
                {/* Add Forgot Password Link */}
                <Typography
                    variant="body2"
                    color="primary"
                    sx={{ textAlign: 'right', mt: 1, mb: 1 }}
                >
                    <Link
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            setForgotPasswordOpen(true); // Open the forgot password modal
                        }}
                    >
                        שכחתי סיסמה
                    </Link>
                </Typography>
                <Typography textAlign="right" direction="rtl" variant="body2" mt={2}>
                    עוד לא נרשמת?{' '}
                    <Link
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            onClose();
                            onRegisterClick(); // Trigger the Register modal
                        }}
                    >
                        רישום
                    </Link>
                </Typography>
                {/* Forgot Password Modal */}
                <ForgotPassword
                    open={forgotPasswordOpen}
                    onClose={() => setForgotPasswordOpen(false)}
                    onSubmit={handleForgotPasswordSubmit}
                />

                {/* Google Sign-In Section */}
                <Box textAlign="center" mt={2}>
                    <Typography variant="body2">Or </Typography>
                    <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mt={1}>
                        <Box textAlign="center" mt={2}>
                            <Stack direction="row" justifyContent="center" spacing={1} mt={1}>
                                <Button
                                    variant="outlined"
                                    onClick={handleGoogleLogin}
                                    sx={{
                                        textTransform: 'none',
                                        color: '#4285F4',
                                        borderColor: '#4285F4',
                                        '&:hover': {
                                            borderColor: '#4285F4',
                                            backgroundColor: '#F1F1F1',
                                        },
                                        padding: '10px 20px',
                                    }}
                                >
                                    <GoogleIcon sx={{ mr: 1 }} />
                                    התחברות באמצעות גוגל
                                </Button>
                            </Stack>
                        </Box>
                    </Stack>
                </Box>
            </Box>

        </Modal >
    );
};

export default Login;
